<template>
  <div class="sonar-recommended">
    <transition name="sonar-recommended--expand">
      <div v-if="isLoading" key="loader" class="sonar-recommended__container" />
      <div v-else key="content" class="sonar-recommended__container--expand">
        <ContentList
          v-if="hasResults"
          class="sonar-recommended__content-list"
          :items="currentItems"
          :searchIndex="algoliaSearchIndex"
          :openInNewTab="true"
        />
        <div v-else class="sonar-recommended__no-results-wrapper">
          <h5 class="sonar-recommended__no-results-title">
            Unlock training recommendations
          </h5>
          <p class="sonar-recommended__no-results-info">
            Take this assessment to receive personalized training
            recommendations based on your performance.
          </p>
          <button
            class="btn btn--primary sonar-recommended__no-results-btn"
            :disabled="isCtaDisabled"
            @click="clickHandler()"
          >
            Test me
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ContentList from '@/components/search/ContentList.vue'
import { recommendedContent } from '@/sonar/helpers/mixins'
import { mapGetters } from 'vuex'

export default {
  name: 'SonarRecommendedContent',
  components: {
    ContentList,
  },
  mixins: [recommendedContent],
  props: {
    parentIds: {
      type: Array,
      required: true,
    },
    difficulty: {
      type: String,
      required: true,
    },
    isCtaDisabled: {
      type: Boolean,
      required: true,
    },
    isResultsModal: {
      type: Boolean,
      required: false,
    },
    recommendedContentItems: {
      type: Array,
      required: false,
      default() {
        return []
      },
    },
  },
  data() {
    return {
      isLoading: true,
    }
  },
  computed: {
    ...mapGetters({
      algoliaSearchIndex: 'sonar/algoliaSearchIndex',
    }),
    hasResults() {
      return this.currentItems.some(item => !!item)
    },
  },
  async created() {
    this.isLoading = true
    this.$emit('is-loading', true)
    if (this.isResultsModal) {
      this.currentItems = this.recommendedContentItems
    } else {
      const skill_area_ids = this.parentIds?.map(p => p.id)
      const payload = {
        skill_area_ids,
      }
      this.currentItems = await this.getAlgoliaItems(payload)
    }
    this.$emit('is-loading', false)
    this.isLoading = false
  },
  destroyed() {
    this.$emit('is-loading', false)
  },
  methods: {
    clickHandler() {
      this.$emit('start-assessment')
    },
  },
}
</script>

<style lang="scss" scoped>
.sonar-recommended {
  width: 100%;
  z-index: 50;
  &__container {
    height: 0;
    &--expand {
      padding: 30px 20px;
      height: 100%;
    }
  }
  &__loading {
    display: flex;
    justify-content: center;
    height: 100px;
    align-items: center;
    width: 100%;
  }
  &__no-results {
    &-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
    }
    &-title {
      color: var(--white);
      font-size: rem(20);
      line-height: rem(26);
      font-family: var(--font-bold);
      margin: 0 0 -5px 0;
      text-align: center;
    }
    &-info {
      font-size: rem(16);
      line-height: rem(24);
      color: var(--light-blue-gray);
      text-align: center;
      margin: 0;
    }
    &-btn {
      height: 36px;
      padding: 8px 16px;
      margin-bottom: 20px;
      font-size: rem(14);
    }
  }
  ::v-deep .content-row {
    &__main-container {
      height: 146px;
      @include mobile {
        height: 106px;
      }
      &__tile-img {
        height: 146px;
        width: 133px;
        @include mobile {
          height: 106px;
        }
      }
      &__info {
        &__top {
          height: fit-content;
        }
        &__title {
          height: fit-content;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          @include mobile {
            -webkit-line-clamp: 1;
          }
        }
      }
    }
  }
  $totalNavbarHeight: calc(var(--navbar-height) + var(--home-banner-height));
  ::v-deep .video-modal {
    padding-top: $totalNavbarHeight;
  }
  ::v-deep .video-modal__close-btn {
    top: $totalNavbarHeight + 10;
  }
  &--expand {
    &-enter-active,
    &-leave-active {
      transition: all 0.2s ease-in-out;
    }
    &-enter,
    &-leave-to {
      padding: 0 20px;
      max-height: 0px;
      opacity: 0;
    }
  }
}
</style>
